import React, { useEffect, useRef } from "react";
import "./about.css";
import AboutImg from "../../assets/about.webp";
import CV from "../../assets/hopemadzicv.pdf";
import Info from "./Info.jsx";

// Optional: add your pet image file to /assets and import it
// import PetImg from "../../assets/pet.jpg";

const About = () => {
  const revealRef = useRef(null);

  useEffect(() => {
    const el = revealRef.current;
    if (!el) return;

    let rafId = null;

    const update = () => {
      const rect = el.getBoundingClientRect();
      const vh = window.innerHeight || 1;

      // progress: 0 when element is below viewport, 1 when it's well inside
      const start = vh * 0.9;
      const end = vh * 0.2;
      const raw = (start - rect.top) / (start - end);
      const progress = Math.max(0, Math.min(1, raw));

      el.style.setProperty("--reveal", String(progress));
      el.style.setProperty("--parallax", String((progress - 0.5) * 2)); // -1..1

      rafId = null;
    };

    const onScroll = () => {
      if (rafId) return;
      rafId = window.requestAnimationFrame(update);
    };

    update();
    window.addEventListener("scroll", onScroll, { passive: true });
    window.addEventListener("resize", onScroll);

    return () => {
      window.removeEventListener("scroll", onScroll);
      window.removeEventListener("resize", onScroll);
      if (rafId) window.cancelAnimationFrame(rafId);
    };
  }, []);

  return (
    <section className="about section" id="about">
      <h2 className="section__title">About Me</h2>
      {/* <span className="section__subtitle">My Introduction</span> */}

      <div className="about__container container grid">
        <div ref={revealRef} className="about__imgReveal">
          <img loading="lazy" src={AboutImg} alt="about" className="about__img" />
        </div>

        <div className="about__data">
          <Info />

          <p className="about__description">
            I hold a Bachelor’s degree in Computer Science and I’m AWS certified,
            which means I enjoy turning caffeine into scalable cloud resources and
            occasionally pretending I understand billing dashboard 😅. I’m naturally
            curious, slightly obsessed with learning new tools, and always
            experimenting responsibly ofcourse hehe.
          </p>

          {/* Optionally add your pet block here (see section 2) */}
          {/*
          <div className="about__pet">
            <img className="about__petImg" src={PetImg} alt="my pet" />
            <div className="about__petText">
              <h3 className="about__petTitle">Meet my sidekick</h3>
              <p className="about__petSub">Chief morale officer</p>
            </div>
          </div>
          */}

          <a download="" href={CV} className="button button--flex">
            Download CV
            <svg
              className="button__icon"
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
            >
              {/* ... keep your paths the same ... */}
            </svg>
          </a>
        </div>
      </div>
    </section>
  );
};

export default About;
